module.exports = __webpack_public_path__ + "img/04.ccc5ac65.jpg";